import { NgModule, InjectionToken } from '@angular/core';
import { RouterModule, ActivatedRouteSnapshot } from '@angular/router';
import { InstructionsComponent } from './instructions/instructions.component';

import { DataEditorComponent } from './data-editor/data-editor.component';
import { EmptyLinkComponent } from './empty-link/empty-link.component';
import { LayoutComponent } from './layout/layout.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { ApplyStatusComponent } from './apply-status/apply-status.component';
import { NonDegreeComponent } from './non-degree/non-degree.component';
import { CertifyResidencyComponent } from './certify-residency/certify-residency.component';
import { AupComponent } from './aup/aup.component';
import { VerifyComponent } from './verify/verify.component';
import { ClaimComponent } from './claim/claim.component';
const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');

/**
 * Add the routing as an array that 'could' be pulled from a 
 * static value service. 
 * 
 * BMS TODO: build a static initialization service that provides the 
 * configuration and the routes (typeof Routes)
 */
@NgModule({
  imports: [RouterModule.forRoot([
    { path: "aup", component: AupComponent },
    { path: "verify/:id", component: VerifyComponent },
    { path: "claim/:id", component: ClaimComponent },
    { path: "editor/:id", component: DataEditorComponent },
    { path: "instructions/:src", component: InstructionsComponent },
    { path: "external", canActivate: [externalUrlProvider], component: EmptyLinkComponent },
    { path: "status", component: ApplyStatusComponent },
    { path: "non-degree", component: NonDegreeComponent },
    { path: "certify-residency", component: CertifyResidencyComponent },
    { path: "apply", component: LayoutComponent },
    { path: "apply/:token/:status", component: LayoutComponent },
    { path: "search", component: LayoutComponent },
    { path: "error", component: ErrorPageComponent },
    { path: "", redirectTo: "/apply", pathMatch: "full" },
  ], {
    scrollPositionRestoration: 'enabled', // Restores scroll position
    anchorScrolling: 'enabled'          // Enables anchor scrolling
  })],
  exports: [RouterModule],
  providers: [
    {
      provide: externalUrlProvider,
      useValue: (route: ActivatedRouteSnapshot) => {
        const extUrl: string | null = route.paramMap?.get('externalUrl'), target: string | null = route.paramMap?.get('target');
        if (extUrl !== null) {
          window.open(extUrl, target ?? '_self');
        }
      },
    }
  ],
})
export class AppRoutingModule { }
